var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.48,
    height: 12.48,
    viewBox: "0 0 12.48 12.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_archive_24px",
    d: "M15.161,4.546,14.2,3.381A1.006,1.006,0,0,0,13.4,3H5.08a1.03,1.03,0,0,0-.8.381L3.319,4.546A1.358,1.358,0,0,0,3,5.427v8.667A1.391,1.391,0,0,0,4.387,15.48h9.707a1.391,1.391,0,0,0,1.387-1.387V5.427A1.358,1.358,0,0,0,15.161,4.546ZM9.24,13.053,5.427,9.24H7.853V7.853h2.773V9.24h2.427ZM4.47,4.387l.562-.693h8.32L14,4.387Z",
    transform: "translate(-3 -3)",
    fill: "#6b6a77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive_icon.9c221242da63839f38b149cf722dbb91.svg";
export { ForwardRef as ReactComponent };